import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Button,
  Alert,
  Spinner,
  Badge,
  Progress
} from "reactstrap";
import {
  TbDownload,
  TbFileText,
  TbClipboardList,
  TbCalendar,
  TbChartBar,
  TbCheck,
  TbX,
  TbRefresh,
  TbFileSpreadsheet,
  TbFileDescription,
  TbUsers,
  TbUser,
  TbMail
} from "react-icons/tb";
import { motion, AnimatePresence } from "framer-motion";
import Swal from "sweetalert2";
import { getDescargarPqrs, getDescargarEscombros, getDescargarProcesosComerciales, getDescargarCorrespondencia } from "../../helpers/backend";
import './DescargaArchivos.css';
import { FaImages } from "react-icons/fa";

const DescargaArchivos = () => {
  const [loading, setLoading] = useState(false);
  const [resultados, setResultados] = useState(null);
  const [tipoDescarga, setTipoDescarga] = useState("");
  const [descargando, setDescargando] = useState(false);
  const [archivoDescarga, setArchivoDescarga] = useState("");
  const [progresoDescarga, setProgresoDescarga] = useState(0);

  const getBaseUrl = () => {
    const URL = process.env.REACT_APP_API_URL;
    const url = URL.split("/api");
    return url[0];
  };

  const mostrarSelectorFechas = async (tipo) => {
    const { value: fechas } = await Swal.fire({
      title: `📊 Generar Reporte - ${tipo}`,
      html: `
        <div class="date-picker-container">
          <div class="mb-3">
            <label for="fecha-inicio" class="form-label fw-semibold text-dark">Fecha de inicio</label>
            <input type="date" id="fecha-inicio" class="form-control date-input" required>
          </div>
          <div class="mb-3">
            <label for="fecha-fin" class="form-label fw-semibold text-dark">Fecha de fin</label>
            <input type="date" id="fecha-fin" class="form-control date-input" required>
          </div>
        </div>
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Generar Reporte",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#4CAF50",
      cancelButtonColor: "#6c757d",
      customClass: {
        popup: 'swal-popup-custom',
        confirmButton: 'swal-confirm-btn',
        cancelButton: 'swal-cancel-btn'
      },
      preConfirm: () => {
        const fechaInicio = document.getElementById("fecha-inicio").value;
        const fechaFin = document.getElementById("fecha-fin").value;

        if (!fechaInicio || !fechaFin) {
          Swal.showValidationMessage("Por favor selecciona ambas fechas");
          return false;
        }

        if (fechaInicio > fechaFin) {
          Swal.showValidationMessage("La fecha de inicio no puede ser mayor a la fecha de fin");
          return false;
        }

        // Validar que no sea una fecha futura
        const hoy = new Date().toISOString().split('T')[0];
        if (fechaInicio > hoy || fechaFin > hoy) {
          Swal.showValidationMessage("No puedes seleccionar fechas futuras");
          return false;
        }

        return { fechaInicio, fechaFin };
      },
    });

    if (fechas) {
      await procesarDescarga(tipo, fechas.fechaInicio, fechas.fechaFin);
    }
  };

  const procesarDescarga = async (tipo, fechaInicio, fechaFin) => {
    setLoading(true);
    setTipoDescarga(tipo);

    try {
      let response;

      if (tipo === "PQRS") {
        response = await getDescargarPqrs(fechaInicio, fechaFin);
      } else if (tipo === "Escombros") {
        response = await getDescargarEscombros(fechaInicio, fechaFin);
      } else if (tipo === "Procesos Comerciales") {
        response = await getDescargarProcesosComerciales(fechaInicio, fechaFin);
      } else if (tipo === "Correspondencia") {
        response = await getDescargarCorrespondencia(fechaInicio, fechaFin);
      }

      if (response && response.data) {
        setResultados(response.data);

        Swal.fire({
          icon: "success",
          title: "✅ Reporte Generado",
          text: `Se procesaron ${response.data.estadisticas?.total_casos || 0} casos exitosamente`,
          timer: 2500,
          showConfirmButton: false,
          customClass: {
            popup: 'swal-popup-custom'
          }
        });
      } else {
        throw new Error("No se recibieron datos del servidor");
      }
    } catch (error) {
      console.error("Error al generar el reporte:", error);

      Swal.fire({
        icon: "error",
        title: "❌ Error",
        text: "Hubo un problema al generar el reporte. Por favor intenta nuevamente.",
        confirmButtonColor: "#4CAF50",
        customClass: {
          popup: 'swal-popup-custom'
        }
      });
    } finally {
      setLoading(false);
    }
  };

  const descargarArchivo = async (url, tipo, formato) => {
    setDescargando(true);
    setArchivoDescarga(`${tipo}-${formato}`);
    setProgresoDescarga(0);

    try {
      // Mostrar SweetAlert con barra de progreso real
      let progressInterval;
      const swalInstance = Swal.fire({
        title: `📥 Descargando ${formato}`,
        html: `
          <div class="download-progress-container">
            <div class="d-flex justify-content-between mb-2">
              <small class="text-muted">Preparando archivo...</small>
              <small class="text-muted" id="progress-percentage">0%</small>
            </div>
            <div class="progress download-progress-bar">
              <div class="progress-bar progress-bar-striped progress-bar-animated" 
                   id="download-progress"
                   style="width: 0%; background: linear-gradient(45deg, #4CAF50, #66BB6A);">
              </div>
            </div>
            <div class="mt-2">
              <small class="text-muted" id="download-status">Iniciando descarga...</small>
            </div>
          </div>
        `,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          const progressBar = document.getElementById('download-progress');
          const progressPercentage = document.getElementById('progress-percentage');
          const downloadStatus = document.getElementById('download-status');

          // Simular progreso inicial
          progressInterval = setInterval(() => {
            setProgresoDescarga(prev => {
              const newProgress = Math.min(prev + Math.random() * 10 + 5, 90);
              progressBar.style.width = `${newProgress}%`;
              progressPercentage.textContent = `${Math.round(newProgress)}%`;

              if (newProgress < 30) {
                downloadStatus.textContent = 'Conectando con el servidor...';
              } else if (newProgress < 60) {
                downloadStatus.textContent = 'Preparando datos...';
              } else if (newProgress < 90) {
                downloadStatus.textContent = 'Generando archivo...';
              }

              return newProgress;
            });
          }, 300);

          // Iniciar descarga real
          setTimeout(async () => {
            try {
              const baseUrl = getBaseUrl();
              const fullUrl = `${baseUrl}${url}`;

              const token = localStorage.getItem("token");
              const fetchHeaders = token ? { 'Authorization': `Bearer ${token}` } : {};
              const response = await fetch(fullUrl, { headers: fetchHeaders });
              const blob = await response.blob();
              const downloadUrl = window.URL.createObjectURL(blob);
              // Determinar la extensión correcta del archivo
              const extension = (() => {
                // 1) Intentar deducir desde la URL
                try {
                  const cleanUrl = fullUrl.split('?')[0];
                  const extFromUrl = cleanUrl.includes('.') ? cleanUrl.split('.').pop().toLowerCase() : '';
                  if (["xlsx", "xls", "txt", "pdf", "csv"].includes(extFromUrl)) {
                    return extFromUrl;
                  }
                } catch (_) { }

                // 2) Intentar deducir desde el Content-Type
                const contentType = response.headers.get('Content-Type') || '';
                if (contentType.includes('officedocument.spreadsheetml.sheet')) return 'xlsx';
                if (contentType.includes('ms-excel')) return 'xls';
                if (contentType.includes('text/plain')) return 'txt';
                if (contentType.includes('pdf')) return 'pdf';
                if (contentType.includes('csv')) return 'csv';

                // 3) Fallback por formato indicado
                if ((formato || '').toLowerCase() === 'excel') return 'xlsx';
                return (formato || 'xlsx').toLowerCase();
              })();

              const link = document.createElement("a");
              link.href = downloadUrl;
              link.download = `reporte-${tipo.toLowerCase().replace(' ', '-')}-${new Date().toISOString().split('T')[0]}.${extension}`;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(downloadUrl);

              // Completar progreso
              clearInterval(progressInterval);
              setProgresoDescarga(100);
              progressBar.style.width = '100%';
              progressPercentage.textContent = '100%';
              downloadStatus.textContent = 'Descarga completada ✓';

              setTimeout(() => {
                Swal.close();
                Swal.fire({
                  icon: "success",
                  title: "✅ Descarga Exitosa",
                  text: `El archivo ${formato} se ha descargado correctamente`,
                  timer: 2000,
                  showConfirmButton: false,
                  customClass: {
                    popup: 'swal-popup-custom'
                  }
                });
              }, 1000);

            } catch (error) {
              clearInterval(progressInterval);
              Swal.fire({
                icon: "error",
                title: "❌ Error en Descarga",
                text: "No se pudo descargar el archivo. Verifica tu conexión.",
                confirmButtonColor: "#4CAF50",
                customClass: {
                  popup: 'swal-popup-custom'
                }
              });
            }
          }, 1500);
        }
      });

    } catch (error) {
      console.error("Error en la descarga:", error);
      Swal.fire({
        icon: "error",
        title: "❌ Error",
        text: "Hubo un problema al descargar el archivo. Por favor intenta nuevamente.",
        confirmButtonColor: "#4CAF50",
        customClass: {
          popup: 'swal-popup-custom'
        }
      });
    } finally {
      setTimeout(() => {
        setDescargando(false);
        setArchivoDescarga("");
        setProgresoDescarga(0);
      }, 2000);
    }
  };

  const tiposReporte = [
    {
      tipo: "PQRS",
      titulo: "Reportes PQRS",
      descripcion: "Peticiones, Quejas, Reclamos y Sugerencias",
      icono: TbClipboardList,
      color: "success",
      detalles: "Genera reportes detallados de todas las PQRS registradas en el sistema durante un período específico."
    },
    {
      tipo: "Escombros",
      titulo: "Reportes Escombros",
      descripcion: "Gestión de residuos y escombros",
      icono: TbFileText,
      color: "warning",
      detalles: "Genera reportes completos de todos los casos relacionados con escombros y residuos de construcción."
    },
    {
      tipo: "Procesos Comerciales",
      titulo: "Procesos Comerciales",
      descripcion: "Gestión de procesos comerciales",
      icono: TbChartBar,
      color: "info",
      detalles: "Genera reportes detallados de todos los procesos comerciales registrados en el sistema."
    },
    {
      tipo: "Correspondencia",
      titulo: "Reportes Correspondencia",
      descripcion: "Gestión de Correspondencia",
      icono: TbMail,
      color: "primary",
      detalles: "Genera reportes completos de la correspondencia gestionada en el sistema."
    }
  ];

  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
    hover: { y: -5, transition: { duration: 0.2 } }
  };

  return (
    <Container fluid className="descarga-archivos-page">
      <div className="page-content">
        {/* Header Mejorado */}
        <motion.div
          className="page-header mb-5"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Row className="align-items-center">

            <Row className="align-items-center">
              <Col>
                <div className="d-flex align-items-center">
                  <div className="gallery-icon-wrapper me-3">
                    <TbDownload size={28} className="text-white" />
                  </div>
                  <div>
                    <h1 className="gallery-title mb-1">Centro de Descargas</h1>
                    <p className="gallery-subtitle mb-0">
                      Genera y descarga reportes personalizados del sistema
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs="auto">

              </Col>
            </Row>
            <Col xs="auto">
              <Badge color="light" className="text-dark fs-6">
                <TbFileText className="me-2" />
                3 Tipos de Reporte
              </Badge>
            </Col>
          </Row>
        </motion.div>

        {/* Tarjetas de Opciones de Descarga */}
        <AnimatePresence>
          {!resultados && !loading && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <Row className="g-4">
                {tiposReporte.map((reporte, index) => (
                  <Col lg={4} md={6} key={reporte.tipo}>
                    <motion.div
                      variants={cardVariants}
                      initial="hidden"
                      animate="visible"
                      whileHover="hover"
                      transition={{ duration: 0.3, delay: index * 0.1 }}
                    >
                      <Card className={`download-option-card download-card-${reporte.color} border-0 shadow-sm h-100`}>
                        <CardHeader className="dlightad-card-header bg-light border-bottom">
                          <div className="d-flex align-items-center">
                            <div className={`download-icon-wrapper me-3 icon-pastel-${reporte.color}`}>
                              <reporte.icono size={24} className={`text-pastel-${reporte.color}`} />
                            </div>
                            <div className="flex-grow-1">
                              <h5 className="download-card-title mb-1">{reporte.titulo}</h5>
                              <p className="download-card-subtitle mb-0">{reporte.descripcion}</p>
                            </div>
                          </div>
                        </CardHeader>
                        <CardBody className="download-card-body">
                          <p className="download-card-text text-muted mb-4">
                            {reporte.detalles}
                          </p>

                          <div className="download-features mb-4">
                            <div className="d-flex align-items-center text-muted mb-2">
                              <TbCalendar className="me-2" size={16} />
                              <small>Selección de rango de fechas</small>
                            </div>
                            <div className="d-flex align-items-center text-muted mb-2">
                              <TbFileSpreadsheet className="me-2" size={16} />
                              <small>Formatos: Excel y TXT</small>
                            </div>
                            <div className="d-flex align-items-center text-muted">
                              <TbChartBar className="me-2" size={16} />
                              <small>Estadísticas detalladas</small>
                            </div>
                          </div>

                          <Button
                            onClick={() => mostrarSelectorFechas(reporte.tipo)}
                            className={`download-action-btn w-100 btn-pastel-${reporte.color}`}
                            size="lg"
                          >
                            <TbDownload className="me-2" size={18} />
                            Generar Reporte {reporte.tipo}
                          </Button>
                        </CardBody>
                      </Card>
                    </motion.div>
                  </Col>
                ))}
              </Row>
            </motion.div>
          )}
        </AnimatePresence>

        {/* Estado de Carga */}
        <AnimatePresence>
          {loading && (
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.3 }}
            >
              <Row>
                <Col>
                  <Card className="loading-card border-0 shadow-sm">
                    <CardBody className="text-center py-5">
                      <div className="loading-spinner-wrapper mb-4">
                        <Spinner color="success" className="loading-spinner" />
                      </div>
                      <h4 className="loading-title mb-2">
                        Generando Reporte de {tipoDescarga}
                      </h4>
                      <p className="loading-subtitle text-muted mb-0">
                        Estamos procesando la información solicitada...
                      </p>
                      <div className="mt-4">
                        <Progress
                          value={75}
                          animated
                          className="mx-auto"
                          style={{ maxWidth: '300px', height: '6px' }}
                        />
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </motion.div>
          )}
        </AnimatePresence>

        {/* Resultados del Reporte */}
        <AnimatePresence>
          {resultados && !loading && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <Card className="results-card border-0 shadow-sm">
                <CardHeader className="results-card-header bg-light border-bottom">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                      <div className="results-icon-wrapper me-3">
                        <TbChartBar size={24} className="text-success" />
                      </div>
                      <div>
                        <h4 className="results-title mb-1">
                          Reporte Generado - {tipoDescarga}
                        </h4>
                        <p className="results-subtitle mb-0 text-muted">
                          Información del período consultado
                        </p>
                      </div>
                    </div>
                    <Button
                      color="outline-primary"
                      onClick={() => {
                        setResultados(null);
                        setTipoDescarga("");
                      }}
                      className="new-report-btn"
                    >
                      <TbRefresh className="me-2" />
                      Nuevo Reporte
                    </Button>
                  </div>
                </CardHeader>
                <CardBody className="results-card-body">
                  {/* Estadísticas Principales */}
                  <Row className="g-4 mb-4">
                    <Col lg={8}>
                      <div className="stats-grid">
                        <div className="stat-item primary">
                          <div className="stat-value">
                            {resultados.estadisticas?.total_casos || 0}
                          </div>
                          <div className="stat-label">Total de Casos</div>
                        </div>
                        {typeof resultados.estadisticas?.total_multiusuario === 'number' && (
                          <div className="stat-item success">
                            <div className="stat-value">
                              {resultados.estadisticas.total_multiusuario}
                            </div>
                            <div className="stat-label">Multiusuario</div>
                          </div>
                        )}
                        {typeof resultados.estadisticas?.total_no_multiusuario === 'number' && (
                          <div className="stat-item warning">
                            <div className="stat-value">
                              {resultados.estadisticas.total_no_multiusuario}
                            </div>
                            <div className="stat-label">No Multiusuario</div>
                          </div>
                        )}
                        {resultados.estadisticas?.tipos_caso_encontrados && (
                          <div className="stat-item success">
                            <div className="stat-value">
                              {resultados.estadisticas.tipos_caso_encontrados.length}
                            </div>
                            <div className="stat-label">Tipos de Caso</div>
                          </div>
                        )}
                        {resultados.estadisticas?.estados_encontrados && (
                          <div className="stat-item info">
                            <div className="stat-value">
                              {resultados.estadisticas.estados_encontrados.length}
                            </div>
                            <div className="stat-label">Estados</div>
                          </div>
                        )}
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="params-card">
                        <h6 className="params-title">Parámetros de Consulta</h6>
                        <div className="params-list">
                          <div className="param-item">
                            <span className="param-label">Fecha Inicio:</span>
                            <span className="param-value">{resultados.parametros_consulta?.fecha_inicio}</span>
                          </div>
                          <div className="param-item">
                            <span className="param-label">Fecha Fin:</span>
                            <span className="param-value">{resultados.parametros_consulta?.fecha_fin}</span>
                          </div>
                          <div className="param-item">
                            <span className="param-label">Tipo de Orden:</span>
                            <span className="param-value">{resultados.parametros_consulta?.tipo_orden}</span>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  {/* Detalles Adicionales */}
                  <Row className="g-4">
                    {resultados.estadisticas?.tipos_caso_encontrados && (
                      <Col md={6}>
                        <div className="detail-card">
                          <h6 className="detail-title">
                            <TbFileText className="me-2" />
                            Tipos de Caso Encontrados
                          </h6>
                          <div className="tags-container">
                            {resultados.estadisticas.tipos_caso_encontrados.map((tipo, index) => (
                              <Badge key={index} color="success" className="tag-badge">
                                {tipo}
                              </Badge>
                            ))}
                          </div>
                        </div>
                      </Col>
                    )}
                    {resultados.estadisticas?.estados_encontrados && (
                      <Col md={6}>
                        <div className="detail-card">
                          <h6 className="detail-title">
                            <TbCheck className="me-2" />
                            Estados Encontrados
                          </h6>
                          <div className="tags-container">
                            {resultados.estadisticas.estados_encontrados.map((estado, index) => (
                              <Badge key={index} color="info" className="tag-badge">
                                {estado}
                              </Badge>
                            ))}
                          </div>
                        </div>
                      </Col>
                    )}
                  </Row>

                  {/* Opciones de Descarga */}
                  <div className="download-options-section mt-4">
                    <div className="download-options-header">
                      <h6 className="download-options-title">
                        <TbDownload className="me-2" />
                        Descargar Reporte
                      </h6>
                      <p className="download-options-subtitle text-muted">
                        Selecciona el formato de descarga
                      </p>
                    </div>
                    {resultados.exportaciones_separadas ? (
                      <div className="download-grid">
                        <div className="download-group group-multiusuario">
                          <div className="group-header">
                            <div className="group-title"><TbUsers className="me-2" />Multiusuario</div>
                            <div className="group-count">{resultados.exportaciones_separadas?.multiusuario?.total || 0} casos</div>
                          </div>
                          <div className="group-formats">
                            <span className="format-label excel"><TbFileSpreadsheet size={16} className="me-1" /> Excel</span>
                            <span className="format-label txt"><TbFileDescription size={16} className="me-1" /> TXT</span>
                          </div>
                          <div className="format-actions">
                            {resultados.exportaciones_separadas?.multiusuario?.excel && (
                              <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
                                <Button
                                  onClick={() => descargarArchivo(resultados.exportaciones_separadas.multiusuario.excel, `${tipoDescarga} Multiusuario`, "Excel")}
                                  disabled={descargando || (resultados.exportaciones_separadas?.multiusuario?.total || 0) === 0}
                                  className="download-pill excel"
                                >
                                  {descargando && archivoDescarga === `${tipoDescarga} Multiusuario-Excel` ? (
                                    <>
                                      <Spinner size="sm" className="me-2" />
                                      .xlsx
                                    </>
                                  ) : (
                                    <>
                                      <TbFileSpreadsheet className="me-2" size={18} />
                                      .xlsx
                                    </>
                                  )}
                                </Button>
                              </motion.div>
                            )}
                            {resultados.exportaciones_separadas?.multiusuario?.txt && (
                              <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
                                <Button
                                  onClick={() => descargarArchivo(resultados.exportaciones_separadas.multiusuario.txt, `${tipoDescarga} Multiusuario`, "TXT")}
                                  disabled={descargando || (resultados.exportaciones_separadas?.multiusuario?.total || 0) === 0}
                                  className="download-pill txt"
                                >
                                  {descargando && archivoDescarga === `${tipoDescarga} Multiusuario-TXT` ? (
                                    <>
                                      <Spinner size="sm" className="me-2" />
                                      .txt
                                    </>
                                  ) : (
                                    <>
                                      <TbFileDescription className="me-2" size={18} />
                                      .txt
                                    </>
                                  )}
                                </Button>
                              </motion.div>
                            )}
                          </div>
                        </div>

                        <div className="download-group group-nomultiusuario">
                          <div className="group-header">
                            <div className="group-title"><TbUser className="me-2" />No Multiusuario</div>
                            <div className="group-count">{resultados.exportaciones_separadas?.no_multiusuario?.total || 0} casos</div>
                          </div>
                          <div className="group-formats">
                            <span className="format-label excel"><TbFileSpreadsheet size={16} className="me-1" /> Excel</span>
                            <span className="format-label txt"><TbFileDescription size={16} className="me-1" /> TXT</span>
                          </div>
                          <div className="format-actions">
                            {resultados.exportaciones_separadas?.no_multiusuario?.excel && (
                              <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
                                <Button
                                  onClick={() => descargarArchivo(resultados.exportaciones_separadas.no_multiusuario.excel, `${tipoDescarga} No Multiusuario`, "Excel")}
                                  disabled={descargando || (resultados.exportaciones_separadas?.no_multiusuario?.total || 0) === 0}
                                  className="download-pill excel"
                                >
                                  {descargando && archivoDescarga === `${tipoDescarga} No Multiusuario-Excel` ? (
                                    <>
                                      <Spinner size="sm" className="me-2" />
                                      .xlsx
                                    </>
                                  ) : (
                                    <>
                                      <TbFileSpreadsheet className="me-2" size={18} />
                                      .xlsx
                                    </>
                                  )}
                                </Button>
                              </motion.div>
                            )}
                            {resultados.exportaciones_separadas?.no_multiusuario?.txt && (
                              <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
                                <Button
                                  onClick={() => descargarArchivo(resultados.exportaciones_separadas.no_multiusuario.txt, `${tipoDescarga} No Multiusuario`, "TXT")}
                                  disabled={descargando || (resultados.exportaciones_separadas?.no_multiusuario?.total || 0) === 0}
                                  className="download-pill txt"
                                >
                                  {descargando && archivoDescarga === `${tipoDescarga} No Multiusuario-TXT` ? (
                                    <>
                                      <Spinner size="sm" className="me-2" />
                                      .txt
                                    </>
                                  ) : (
                                    <>
                                      <TbFileDescription className="me-2" size={18} />
                                      .txt
                                    </>
                                  )}
                                </Button>
                              </motion.div>
                            )}
                          </div>
                        </div>

                        {resultados.plano_cobro && (
                          <div className="download-group group-plano">
                            <div className="group-header">
                              <div className="group-title">Plano de Cobro</div>
                            </div>
                            <div className="group-formats">
                              <span className="format-label excel"><TbFileSpreadsheet size={16} className="me-1" /> Excel</span>
                              <span className="format-label txt"><TbFileDescription size={16} className="me-1" /> TXT</span>
                            </div>
                            <div className="format-actions">
                              {resultados.plano_cobro?.excel && (
                                <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
                                  <Button
                                    onClick={() => descargarArchivo(resultados.plano_cobro.excel, `${tipoDescarga} Plano de Cobro`, "Excel")}
                                    disabled={descargando}
                                    className="download-pill excel"
                                  >
                                    {descargando && archivoDescarga === `${tipoDescarga} Plano de Cobro-Excel` ? (
                                      <>
                                        <Spinner size="sm" className="me-2" />
                                        .xlsx
                                      </>
                                    ) : (
                                      <>
                                        <TbFileSpreadsheet className="me-2" size={18} />
                                        .xlsx
                                      </>
                                    )}
                                  </Button>
                                </motion.div>
                              )}
                              {resultados.plano_cobro?.txt && (
                                <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
                                  <Button
                                    onClick={() => descargarArchivo(resultados.plano_cobro.txt, `${tipoDescarga} Plano de Cobro`, "TXT")}
                                    disabled={descargando}
                                    className="download-pill txt"
                                  >
                                    {descargando && archivoDescarga === `${tipoDescarga} Plano de Cobro-TXT` ? (
                                      <>
                                        <Spinner size="sm" className="me-2" />
                                        .txt
                                      </>
                                    ) : (
                                      <>
                                        <TbFileDescription className="me-2" size={18} />
                                        .txt
                                      </>
                                    )}
                                  </Button>
                                </motion.div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className="download-buttons-container">
                        {resultados.url_descarga_excel && (
                          <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
                            <Button
                              onClick={() => descargarArchivo(resultados.url_descarga_excel, tipoDescarga, "Excel")}
                              disabled={descargando}
                              className="download-pill excel"
                            >
                              {descargando && archivoDescarga === `${tipoDescarga}-Excel` ? (
                                <>
                                  <Spinner size="sm" className="me-2" />
                                  .xlsx
                                </>
                              ) : (
                                <>
                                  <TbFileSpreadsheet className="me-2" size={18} />
                                  .xlsx
                                </>
                              )}
                            </Button>
                          </motion.div>
                        )}
                        {resultados.url_descarga_txt && (
                          <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
                            <Button
                              onClick={() => descargarArchivo(resultados.url_descarga_txt, tipoDescarga, "TXT")}
                              disabled={descargando}
                              className="download-pill txt"
                            >
                              {descargando && archivoDescarga === `${tipoDescarga}-TXT` ? (
                                <>
                                  <Spinner size="sm" className="me-2" />
                                  .txt
                                </>
                              ) : (
                                <>
                                  <TbFileDescription className="me-2" size={18} />
                                  .txt
                                </>
                              )}
                            </Button>
                          </motion.div>
                        )}
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </Container>
  );
};

export default DescargaArchivos;
